var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartup = function SvgStartup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M38.482 31.749c.924-1.727 5.572-7.08 13.321-2.007 7.75 5.073 17.19.571 15.292-9.648-1.301-6.97-10.778-12.409-20.012-9.1C40.915 13.21 33.676 20.983 31 29.121l7.47 2.616z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M63.007 58.917C63.007 64.292 49.935 65 33.81 65c-16.126 0-29.198-.708-29.198-6.083s13.072-9.732 29.198-9.732c16.125 0 29.197 4.357 29.197 9.732"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "M22.017 31.31C25.5 29.5 33 31.31 33.5 37.5c-8-5.5-7.47.962-11.345-.15-2.963-.85-2.648-4.735-.138-6.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M28.59 51.24c2.434-8.503 4.137-15.437 2.434-20.632-.609-1.861-4.258-7.944-12.774-4.295S1.218 23.88 4.868 14.148c2.494-6.643 12.774-10.34 21.29-5.475 5.693 3.249 11.46 12.166 12.676 20.658 1.314 9.148-2.409 18.88-3.552 23.747-1.217 4.866-8.516 2.433-6.691-1.837"
  })));
};
export default SvgStartup;